var cascadeVault = {
    "50O": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/TERM_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/TERM_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "50O_0204_0"
      }
    ],
    "AMP": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Amp_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Amp_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "AMP_0404_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Amp_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Amp_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 1,
        "ffId": "AMP_0604_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Amp_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Amp_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 2,
        "ffId": "AMP_0804_2"
      },
      {
        "h": 8,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Amp_0808.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Amp_0808_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 4
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 3,
        "ffId": "AMP_0808_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Amp_1204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Amp_1204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 12,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 12,
        "index": 4,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Amp_0304.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Amp_0304_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 3,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 3,
        "index": 5,
        "ffId": "AMP_0304_5"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Amp_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Amp_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 6,
        "ffId": "AMP_0204_6"
      },
      {
        "h": 10,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/AMP_0810.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/AMP_0810_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 5
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 8,
            "y": 5
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 7,
        "ffId": "AMP_0810_7"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/AMP_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/AMP_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 8,
        "ffId": "AMP_0609_8"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/AMP_0509.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/AMP_0509_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 5,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 5,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 5,
        "index": 9,
        "ffId": "AMP_0509_9"
      },
      {
        "h": 5,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/AMP_0505.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/AMP_0505_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 3
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 5,
            "y": 3
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 5,
        "index": 10,
        "ffId": "AMP_0505_10"
      }
    ],
    "BLN": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BLN_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BLN_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "BLN_0404_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BLN_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BLN_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "BLN_0409_1"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BLN_0409_1.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BLN_0409_1_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 2,
        "ffId": "BLN_0409_2"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BLN_0409_2.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BLN_0409_2_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 3,
        "ffId": "BLN_0409_3"
      }
    ],
    "BPF": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "BPF_0204_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 1,
        "ffId": "BPF_0604_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_1204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_1204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 12,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 12,
        "index": 2,
        "ffId": "BPF_1204_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 3,
        "ffId": "BPF_0804_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 4,
        "ffId": "BPF_0404_4"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_1004.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_1004_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 10,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 10,
        "index": 5,
        "ffId": "BPF_1004_5"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_0804_DropOn.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_0804_DropOn_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 10,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 10,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "0804 Drop On",
        "w": 10,
        "index": 6,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_1404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_1404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 14,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 14,
        "index": 7,
        "ffId": "BPF_1404_7"
      },
      {
        "h": 8,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_0808.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_0808_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 8,
        "ffId": "BPF_0808_8"
      },
      {
        "h": 7,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_1007.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_1007_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 10,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 10,
        "index": 9,
        "ffId": "BPF_1007_9"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_1804_PUR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_1804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 18,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 18,
        "index": 10,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_2204_PUR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_2204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 22,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 22,
        "index": 11,
        "ffId": ""
      }
    ],
    "BPT": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BPF_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BPF_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 0,
        "ffId": "BPT_0604_0"
      }
    ],
    "BSF": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BSF_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BSF_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BSF_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BSF_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BSF_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BSF_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 2,
        "ffId": "BSF_0604_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BSF_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BSF_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 3,
        "ffId": "BSF_0804_6"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BSF_1004.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BSF_1004_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 10,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 10,
        "index": 4,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BSF_1204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BSF_1204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 12,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 12,
        "index": 5,
        "ffId": ""
      }
    ],
    "BTE": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BTE_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BTE_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "BTE_0404_0"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BTE_0406.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BTE_0406_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 6
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "BTE_0406_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BTE_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BTE_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 2,
        "index": 2,
        "ffId": "BTE_0204_2"
      }
    ],
    "CIR": [
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CIR_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CIR_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "P1",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "P3",
            "type": "HY2",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "P2",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "LT-1 RT-2 LB-3",
        "w": 6,
        "index": 0,
        "ffId": "CIR_0609_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CIR_0609_1.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CIR_0609_1_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "P1",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "P3",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "P2",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "LT-1 RT-2 RB-3",
        "w": 6,
        "index": 1,
        "ffId": "CIR_0609_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CIR_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CIR_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "COM",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "TX",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RX",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 2,
        "ffId": "CIR_0404_2"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/ISO_1009.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/ISO_1009_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 10,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "Isolator PCB 988",
        "w": 10,
        "index": 3,
        "ffId": "CIR_1009_3"
      }
    ],
    "CMP": [
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CMP_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CMP_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 0,
        "ffId": "CMP_0609_0"
      }
    ],
    "CPL": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0404_SR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0404_SR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "S-THRU,R-CPL",
        "w": 4,
        "index": 0,
        "ffId": "CPL_0404_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0404_LR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0404_LR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-THRU,R-CPL",
        "w": 4,
        "index": 1,
        "ffId": "CPL_0404_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0404_LS.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0404_LS_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-THRU,S-CPL",
        "w": 4,
        "index": 2,
        "ffId": "CPL_0404_5"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0804_SR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0804_SR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Straight-Right",
        "w": 8,
        "index": 3,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0604_SR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0604_SR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 4,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Straight-Right",
        "w": 6,
        "index": 4,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0404_RS.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0404_RS_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-CPL,S-THRU",
        "w": 4,
        "index": 5,
        "ffId": "CPL_0404_5"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "TOP-IN L-THRU,R-CPL",
        "w": 4,
        "index": 6,
        "ffId": "CPL_0409_6"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0409_R.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0409_R_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "BOT-IN L-THRU,R-CPL",
        "w": 4,
        "index": 7,
        "ffId": "CPL_0409_6"
      },
      {
        "h": 12,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CPL_1212.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CPL_1212_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "CPLD",
            "type": "OUT",
            "x": 3,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "THRU",
            "type": "OUT",
            "x": 12,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "S-THRU,R-CPL",
        "w": 12,
        "index": 8,
        "ffId": "CPL_1212_8"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CPL_0904.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CPL_0904_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "THRU",
            "type": "OUT",
            "x": 9,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "OUT",
            "x": 7,
            "y": 0
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 9,
        "index": 9,
        "ffId": "CPL_0904_9"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CPL_0804_FR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CPL_0804_FR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "HY1",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "HY2",
            "x": 6,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "THRU",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 10,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CPL_0804_FR_1.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CPL_0804_FR_1_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "THRU",
            "type": "OUT",
            "x": 8,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "HY2",
            "x": 6,
            "y": 0
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "HY1",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 11,
        "ffId": ""
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CPL_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CPL_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "ISO",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "OUT",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "THRU",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 12,
        "ffId": "CPL_0609_12"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0604_SR_1.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0604_SR_1_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "OUT",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "THRU",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 13,
        "ffId": "CPL_0604_13"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Coupler_0404_SR_REV.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Coupler_0404_SR_REV_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "THRU",
            "type": "HY2",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "CPLD",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "reversed 0404 cpl",
        "w": 4,
        "index": 14,
        "ffId": "CPL_0404_0"
      }
    ],
    "CTL": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0804.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 0,
        "ffId": "VRG_0804_8"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0604.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 1,
        "ffId": "VRG_0604_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0404.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 2,
        "ffId": "VRG_0404_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0409_0.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0409_0.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 3,
        "ffId": "BCO_0409_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0104.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0104.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 1,
        "index": 4,
        "ffId": "GCB_0104_4"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0609.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 5,
        "ffId": "BCO_0609_5"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0204.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 6,
        "ffId": "BCO_0204_6"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0304.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0304.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 3,
        "index": 7,
        "ffId": "VRG_0304_5"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0809.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0809.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 8,
        "ffId": "BCO_0809_9"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0809_1.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0809_1.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 9,
        "ffId": "BCO_0809_9"
      },
      {
        "h": 12,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0612.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0612.svg"
          }
        ],
        "ports": [],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 10,
        "ffId": "BCO_0612_10"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0819.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0819.svg"
          }
        ],
        "ports": [],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 11,
        "ffId": "BCO_0819_11"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0419.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0419.svg"
          }
        ],
        "ports": [],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 12,
        "ffId": "BCO_0419_12"
      },
      {
        "h": 8,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0808.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0808.svg"
          }
        ],
        "ports": [],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 13,
        "ffId": ""
      },
      {
        "h": 5,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0405.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0405.svg"
          }
        ],
        "ports": [],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 14,
        "ffId": "VRG_0405_6"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/CTL_0619.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/CTL_0619.svg"
          }
        ],
        "ports": [],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 15,
        "ffId": "BCO_0619_15"
      }
    ],
    "DIO": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DIO_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DIO_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": ""
      }
    ],
    "DIV": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Divider_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Divider_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "DIV_0404_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Divider_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Divider_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 1,
        "ffId": "DIV_0804_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Divider_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Divider_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 2,
        "ffId": "DIV_0604_2"
      }
    ],
    "DMD": [
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Demod_0819.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Demod_0819_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 6,
            "y": 19
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "nQ",
            "type": "HY2",
            "x": 8,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "Q",
            "type": "HY2",
            "x": 8,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "I",
            "type": "HY2",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "nI",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 0,
        "ffId": "DMD_0819_0"
      }
    ],
    "DNC": [
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/IQ_DN_Converter_0819.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/IQ_DN_Converter_0819_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RFIN",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "-LO",
            "type": "INP",
            "x": 2,
            "y": 19
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+LO\"",
            "type": "INP",
            "x": 6,
            "y": 19
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "-I",
            "type": "OUT",
            "x": 8,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+I\"",
            "type": "OUT",
            "x": 8,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+Q\"",
            "type": "OUT",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "-Q",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 0,
        "ffId": "DNC_0819_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/IQ_DN_Converter_0809.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/IQ_DN_Converter_0809_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "-LO",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+LO\"",
            "type": "INP",
            "x": 6,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+I\"",
            "type": "OUT",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+Q\"",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 1,
        "ffId": ""
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_0909.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_0909_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "-LO",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "\"+LO\"",
            "type": "INP",
            "x": 7,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "\"+I\"",
            "type": "OUT",
            "x": 9,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "\"+Q\"",
            "type": "OUT",
            "x": 9,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 9,
        "index": 2,
        "ffId": "DNC_0909_2"
      }
    ],
    "DPX": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DPX_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DPX_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "HPF",
            "type": "HY2",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LPF",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "DPX_0404_0"
      }
    ],
    "DSA": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DSA_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DSA_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 0,
        "ffId": "DSA_0604_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DSA_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DSA_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "DSA_0404_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DSA_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DSA_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 2,
        "ffId": "DSA_0804_2"
      }
    ],
    "DTC": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DTC_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DTC_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "DTC_0404_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DTC_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DTC_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 1,
        "ffId": "DTC_0204_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DTC_0404_1.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DTC_0404_1_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 2,
        "ffId": "DTC_0404_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/DTC_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/DTC_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 3,
        "ffId": "DTC_0604_3"
      }
    ],
    "EQL": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/EQ_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/EQ_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "EQL_0204_0"
      }
    ],
    "HOU": [
      {
        "h": 16,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/16x16Plate_NT.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 16,
        "index": 0,
        "ffId": "PPT_1616_0"
      },
      {
        "h": 32,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/32x32Plate_NT.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 32,
        "index": 1,
        "ffId": "PPT_3232_1"
      },
      {
        "h": 2,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Ruler.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Ruler",
        "w": 36,
        "index": 2,
        "ffId": "RLR_3602_0"
      },
      {
        "h": 1,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/WALL_0301.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Wall",
        "w": 3,
        "index": 3,
        "ffId": "XMW_0301_3"
      },
      {
        "h": 1,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/WALL_0401.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Wall",
        "w": 4,
        "index": 4,
        "ffId": "XMW_0401_4"
      },
      {
        "h": 1,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/WALL_0501.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Wall",
        "w": 5,
        "index": 5,
        "ffId": "XMW_0501_5"
      },
      {
        "h": 1,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/WALL_0601.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Wall",
        "w": 6,
        "index": 6,
        "ffId": "XMW_0601_6"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LID_0204.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Lid",
        "w": 3,
        "index": 7,
        "ffId": "LID_0306_4"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LID_0204_T.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "T-Lid",
        "w": 4,
        "index": 8,
        "ffId": "LID_0406_5"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LID_0304.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Lid",
        "w": 4,
        "index": 9,
        "ffId": "LID_0406_5"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LID_0404.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Lid",
        "w": 5,
        "index": 10,
        "ffId": "LID_0506_6"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LID_0804.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Lid",
        "w": 9,
        "index": 11,
        "ffId": "LID_0906_7"
      },
      {
        "h": 21,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/0819_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "0819 grid",
        "w": 10,
        "index": 12,
        "ffId": "MHO_0819_2"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/2404_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "2404 grid",
        "w": 26,
        "index": 13,
        "ffId": "MHO_2404_4"
      },
      {
        "h": 8,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/US_QUARTER.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "US Quarter",
        "w": 8,
        "index": 14,
        "ffId": "USQ_0808_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/0504_connector.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 5,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Connector",
        "w": 5,
        "index": 15,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Probe.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 5,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Probe",
        "w": 5,
        "index": 16,
        "ffId": ""
      },
      {
        "h": 2,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Shield.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Shield",
        "w": 4,
        "index": 17,
        "ffId": "SHD_0402_0"
      },
      {
        "h": 2,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Pin_Bridge.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Pin_Bridge",
        "w": 4,
        "index": 18,
        "ffId": "SHD_0402_0"
      },
      {
        "h": 1,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Anchor_0401.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Anchor",
        "w": 4,
        "index": 19,
        "ffId": "XMW_0401_4"
      },
      {
        "h": 2,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/GSG_0202.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "GSG Jumper",
        "w": 2,
        "index": 20,
        "ffId": "GJM_0202_0"
      },
      {
        "h": 1,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Anchor_AL_0401.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Anchor AL",
        "w": 4,
        "index": 21,
        "ffId": "XMW_0401_4"
      },
      {
        "h": 1,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Anchor_AR_0401.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Anchor AR",
        "w": 4,
        "index": 22,
        "ffId": "XMW_0401_4"
      },
      {
        "h": 1,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Anchor_AA_0401.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "Anchor AA",
        "w": 4,
        "index": 23,
        "ffId": "XMW_0401_4"
      },
      {
        "h": 21,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/0419_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "0419 grid",
        "w": 6,
        "index": 24,
        "ffId": ""
      },
      {
        "h": 11,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/0809_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "0809 grid",
        "w": 10,
        "index": 25,
        "ffId": ""
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/0404_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "0404 grid",
        "w": 6,
        "index": 26,
        "ffId": "MHO_0404_0"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/0604_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "0604 grid",
        "w": 8,
        "index": 27,
        "ffId": ""
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/0804_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "0804 grid",
        "w": 10,
        "index": 28,
        "ffId": "MHO_0804_1"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/1004_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "1004 grid",
        "w": 12,
        "index": 29,
        "ffId": "MHO_1004_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PB4_0404.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 30,
        "ffId": ""
      },
      {
        "h": 21,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/2919_HSG.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/2919_HSG.svg"
          }
        ],
        "ports": [],
        "szUnit": "",
        "tag": "",
        "w": 31,
        "index": 31,
        "ffId": "MHO_2919_5"
      }
    ],
    "HPF": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/HPF_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/HPF_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "HPF_0204_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/HPF_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/HPF_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "HPF_0404_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/HPF_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/HPF_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 2,
        "ffId": "HPF_0604_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/HPF_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/HPF_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 3,
        "ffId": "HPF_0804_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/HPF_1404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/HPF_1404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 14,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 14,
        "index": 4,
        "ffId": ""
      }
    ],
    "LPF": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LPF_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/LPF_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "LPF_0204_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LPF_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/LPF_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "LPF_0404_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LPF_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/LPF_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 2,
        "ffId": "LPF_0604_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LPF_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/LPF_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 3,
        "ffId": "LPF_0804_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LPF_1004.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/LPF_1004_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 10,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 10,
        "index": 4,
        "ffId": "LPF_1004_4"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/LPF_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/LPF_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 7
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 5,
        "ffId": "LPF_0609_5"
      }
    ],
    "MOD": [
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MOD_0819_1_PUR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MOD_0819_1_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 2,
            "y": 19
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 6,
            "y": 19
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 0
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Variant 1",
        "w": 8,
        "index": 0,
        "ffId": ""
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mod_0819_2.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 8,
            "y": 12
          }
        ],
        "szUnit": "XUN",
        "tag": "Variant 2",
        "w": 8,
        "index": 1,
        "ffId": ""
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mod_0819_3.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mod_0819_3_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 6,
            "y": 0
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Variant 3",
        "w": 8,
        "index": 2,
        "ffId": "MOD_0819_2"
      }
    ],
    "MUL": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mult_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mult_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "MUL_0404_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mult_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mult_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 1,
        "ffId": "MUL_0604_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mult_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mult_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 2,
        "ffId": "MUL_0804_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mult_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mult_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 3,
        "ffId": "MUL_0204_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mult_0304.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mult_0304_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 3,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 3,
        "index": 4,
        "ffId": "MUL_0304_4"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MUL_2404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MUL_2404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 24,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 24,
        "index": 5,
        "ffId": ""
      }
    ],
    "MXR": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0404_02.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0404_02_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-LO,S-IF",
        "w": 4,
        "index": 0,
        "ffId": "MXR_0404_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0404_03.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0404_03_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "S-IF,R-LO",
        "w": 4,
        "index": 1,
        "ffId": "MXR_0404_13"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0404_01.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0404_01_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-IF,S-LO",
        "w": 4,
        "index": 2,
        "ffId": "MXR_0404_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0404_04.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0404_04_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "S-LO,R-IF",
        "w": 4,
        "index": 3,
        "ffId": "MXR_0404_13"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0404_05.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0404_05_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-IF,R-LO",
        "w": 4,
        "index": 4,
        "ffId": "MXR_0404_4"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0404_06.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0404_06_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-LO,R-IF",
        "w": 4,
        "index": 5,
        "ffId": "MXR_0404_4"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0904.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0904_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 7,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 9,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "L-LO,S-IF",
        "w": 9,
        "index": 6,
        "ffId": "MXR_0904_6"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0604-topIF.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0604-topIF_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 6,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 3,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-IF,S-LO",
        "w": 6,
        "index": 7,
        "ffId": "MXR_0604_9"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_IQ_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_IQ_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF1",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF2",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "2 Port IF",
        "w": 6,
        "index": 8,
        "ffId": "MXR_0609_8"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0604-topLO.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0604-topLO_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 6,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 3,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-LO,S-IF",
        "w": 6,
        "index": 9,
        "ffId": "MXR_0604_9"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0604-botLO.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0604-botLO_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 3,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "S-IF,R-LO",
        "w": 6,
        "index": 10,
        "ffId": "MXR_0604_10"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_AB_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_AB_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RFA",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RFB",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IFB",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IFA",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "2 port IF and RF",
        "w": 4,
        "index": 11,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0404_03_r180.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0404_03_r180_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "S-IF,R-LO 180°",
        "w": 4,
        "index": 12,
        "ffId": "MXR_0404_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0404_02_r180.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0404_02_r180_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "L-LO,S-IF 180°",
        "w": 4,
        "index": 13,
        "ffId": "MXR_0404_13"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0406_IF-left.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0406_IF-left_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF",
            "type": "HY2",
            "x": 0,
            "y": 3
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 2,
            "y": 6
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-IF Top-LO Bot-RF",
        "w": 4,
        "index": 14,
        "ffId": "MXR_0406_16"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0409_2portIF-T-LO-BL-RF-R-IF.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0409_2portIF-T-LO-BL-RF-R-IF_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF2",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "IF1",
            "type": "HY2",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "2 port IF (top LO, bot left RF, right IF)",
        "w": 4,
        "index": 15,
        "ffId": "MXR_0409_15"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0406_IF-left.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0406_IF-left_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF",
            "type": "HY1",
            "x": 0,
            "y": 3
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RF",
            "type": "HY2",
            "x": 2,
            "y": 6
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-IF Bot-LO Top-RF",
        "w": 4,
        "index": 16,
        "ffId": "MXR_0406_16"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_0409_2.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_0409_2_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF2",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF1",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 17,
        "ffId": "MXR_0409_17"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_0409_IQ.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_0409_IQ_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF1",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF2",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RF",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 18,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_0404_RIL.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_0404_RIL_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "LO",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF",
            "type": "INP",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RF",
            "type": "HY1",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 19,
        "ffId": "MXR_0404_19"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_20.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_20_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "LO",
            "type": "INP",
            "x": 3,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF2",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF1",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 20,
        "ffId": "MXR_0609_20"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_1009.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_1009_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF1",
            "type": "HY1",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RF",
            "type": "HY2",
            "x": 10,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF2",
            "type": "HY2",
            "x": 10,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "LO",
            "type": "INP",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 10,
        "index": 21,
        "ffId": "MXR_1009_21"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Mixer_0604-topLO_2.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Mixer_0604-topLO_2_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RF",
            "type": "HY2",
            "x": 6,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "LO",
            "type": "INP",
            "x": 3,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 22,
        "ffId": "MXR_0604_9"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_0809RLI.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_0809RLI_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 7,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "PLACEHOLDER DELETE LATER",
        "w": 8,
        "index": 23,
        "ffId": "MXR_0809_23"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_24.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_24_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF1",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "IF2",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "LO",
            "type": "INP",
            "x": 4,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RF",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 24,
        "ffId": "MXR_0609_24"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MXR_0809RLI.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MXR_0809RLI_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 6,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "png is old, svg has mxr icon",
        "w": 8,
        "index": 25,
        "ffId": ""
      }
    ],
    "OSC": [
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/OSC_0809.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/OSC_0809_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "2 port",
        "w": 8,
        "index": 0,
        "ffId": ""
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/OSC_0809.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/OSC_0809_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VTUNE",
            "type": "INP",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 1,
        "ffId": "OSC_0809_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/OSC_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/OSC_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "1 port",
        "w": 4,
        "index": 2,
        "ffId": "OSC_0404_2"
      }
    ],
    "PAC": [
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/MPAC_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/MPAC_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 0,
        "ffId": "PAC_0609_0"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PHC_0819.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PHC_0819_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 2,
            "y": 19
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 8,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 8,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 1,
        "ffId": "PAC_0819_1"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PAC-1919-PCB1818-UTL.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PAC-1919-PCB1818-UTL.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 8
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 11
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 19,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 19,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 19,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 19,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "ADAR1000",
        "w": 19,
        "index": 2,
        "ffId": "PAC_1919_2"
      }
    ],
    "PAD": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PAD_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PAD_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "PAD_0204_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/ATTN_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/ATTN_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "PAD_0404_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Attn_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Attn_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 2,
        "ffId": ""
      }
    ],
    "PLL": [
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PLL_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PLL_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "REFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "INP",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VTUNE",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "PLL_0409_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PLL_0809.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PLL_0809_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "REFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "INP",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VTUNE",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 1,
        "ffId": ""
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PLL_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PLL_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "REFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "VCO",
            "type": "INP",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "VTUNE",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 2,
        "ffId": "PLL_0609_2"
      }
    ],
    "PLM": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Limiter_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Limiter_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "PLM_0204_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Limiter_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Limiter_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "PLM_0404_1"
      }
    ],
    "PSH": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PHS_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PHS_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PHS_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PHS_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 1,
        "ffId": "PSH_0604_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PHS_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PHS_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 2,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/PHS_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/PHS_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 3,
        "ffId": "PSH_0204_3"
      }
    ],
    "SP2": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0404_LR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Splitter_0404_LR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Right",
        "w": 4,
        "index": 0,
        "ffId": "SP2_0404_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0409_L.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Splitter_0409_L_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Com Top-Left",
        "w": 4,
        "index": 1,
        "ffId": "SP2_0409_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SP2_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 2,
        "ffId": "SP2_0604_2"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0419.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Splitter_0419_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 3,
        "ffId": "SP2_0419_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0404_LS.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Splitter_0404_LS_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Straight",
        "w": 4,
        "index": 4,
        "ffId": "SP2_0404_4"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0404_SR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Splitter_0404_SR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Straight-Right",
        "w": 4,
        "index": 5,
        "ffId": "SP2_0404_5"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0409_R.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Splitter_0409_R_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Com Bot-Left",
        "w": 4,
        "index": 6,
        "ffId": "SP2_0409_6"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0404_LSR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Splitter_0404_LSR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Straight-Right",
        "w": 4,
        "index": 7,
        "ffId": ""
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0619.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Splitter_0619_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 8,
        "ffId": "SP2_0619_8"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2_0419_2-way.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SP2_0419_2-way_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "2 way",
        "w": 4,
        "index": 9,
        "ffId": "SP2_0419_9"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SP2_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Com Top-Left",
        "w": 6,
        "index": 10,
        "ffId": "SP2_0609_10"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2_0604_LS.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SP2_0604_LS_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Straight",
        "w": 6,
        "index": 11,
        "ffId": ""
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2_0609_Bot.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SP2_0609_Bot_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Com Bot-Left",
        "w": 6,
        "index": 12,
        "ffId": "SP2_0609_12"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Splitter_0509.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 5,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 5,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 5,
        "index": 13,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2-0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SP2-0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 14,
        "ffId": "SP2_0804_14"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2-0604-14.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SP2-0604-14_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 3,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 15,
        "ffId": "SP2_0604_15"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2_0609_1.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 16,
        "ffId": "SP2_0609_16"
      }
    ],
    "SW2": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0404_LR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0404_LR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Right",
        "w": 4,
        "index": 0,
        "ffId": "SW2_0404_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Com Top-Left",
        "w": 4,
        "index": 1,
        "ffId": "SW2_0409_1"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0409_I1O57.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0409_I1O57_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Com Bot-Left",
        "w": 4,
        "index": 2,
        "ffId": "SW2_0409_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 3,
        "ffId": "SW2_0604_3"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0419.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0419_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 4,
        "ffId": "SW2_0419_4"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/ADI_Weird_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/ADI_Weird_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Path-Switch",
        "w": 4,
        "index": 5,
        "ffId": "SW2_0409_21"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0404_LS.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0404_LS_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Straight",
        "w": 4,
        "index": 6,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0404_SR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0404_SR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Straight-Right",
        "w": 4,
        "index": 7,
        "ffId": "SW2_0404_7"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0819.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0819_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 8,
        "ffId": "SW2_0819_8"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0204_S.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0204_S_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 9,
        "ffId": "SW2_0204_9"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0404_LSR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0404_LSR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Straight-Right",
        "w": 4,
        "index": 10,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0404_S.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0404_S_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Straight",
        "w": 4,
        "index": 11,
        "ffId": "SW2_0404_11"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0619.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0619_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 12,
        "ffId": "SW2_0619_12"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch-0409-4way.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch-0409-4way_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Com Top-Left 4-way",
        "w": 4,
        "index": 13,
        "ffId": "SW2_0409_13"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0804_DPDT.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0804_DPDT_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 8,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 0
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "DPDT",
        "w": 8,
        "index": 14,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SW2_0604_LS.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SW2_0604_LS_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Straight",
        "w": 6,
        "index": 15,
        "ffId": "SW2_0604_15"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SW2_0609_Com-TL.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SW2_0609_Com-TL_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "Com Top-Left",
        "w": 6,
        "index": 16,
        "ffId": "SW2_0609_16"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0619_6-way.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0619_6-way_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "6-way",
        "w": 6,
        "index": 17,
        "ffId": "SW2_0619_17"
      },
      {
        "h": 6,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0406_LR.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0406_LR_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 3
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 6
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "Left-Right",
        "w": 4,
        "index": 18,
        "ffId": "SW2_0406_18"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SW2_0604_LS.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SW2_0604_LS_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 19,
        "ffId": ""
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SP2_0809.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SP2_0809_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 8,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 20,
        "ffId": "SW2_0809_20"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/SW2_0409_4.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/SW2_0409_4_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "INP",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 4,
        "index": 21,
        "ffId": "SW2_0409_21"
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Switch_0619_1.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Switch_0619_1_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 6,
        "index": 22,
        "ffId": "SW2_0619_22"
      }
    ],
    "SYN": [
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VCO-PLL_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/VCO-PLL_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "REFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "SYN_0409_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VCO-PLL_0609.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/VCO-PLL_0609_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "REFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 6,
            "y": 7
          }
        ],
        "szUnit": "XUN",
        "tag": "lower output",
        "w": 6,
        "index": 1,
        "ffId": "SYN_0609_1"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VCO-PLL_0609_1.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/VCO-PLL_0609_1_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "REFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO B",
            "type": "OUT",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO A",
            "type": "OUT",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 2,
        "ffId": "SYN_0609_3"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VCO-PLL_0609_2.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/VCO-PLL_0609_2_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "REFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "HY1",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "REF, RF1, RF2",
        "w": 6,
        "index": 3,
        "ffId": "SYN_0609_3"
      },
      {
        "h": 8,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VCO-PLL_0408.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/VCO-PLL_0408_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "REFIN",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "MUX",
            "type": "OUT",
            "x": 4,
            "y": 6
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "vco and mux",
        "w": 4,
        "index": 4,
        "ffId": "SYN_0408_4"
      }
    ],
    "TML": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "TML_0204_0"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "TML_0404_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_90deg_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_90deg_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 4
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 2,
        "ffId": "TML_0404_16"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_0304.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_0304_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 3,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 3,
        "index": 3,
        "ffId": "TML_0304_3"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_0604.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_0604_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 6,
        "index": 4,
        "ffId": "TML_0604_4"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_0804.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_0804_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 5,
        "ffId": "TML_0804_5"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_1004.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_1004_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 10,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 10,
        "index": 6,
        "ffId": "TML_1004_6"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_180deg_0209.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_180deg_0209_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 0,
            "y": 7
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 7,
        "ffId": "TML_0209_7"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_180deg_0409.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 0,
            "y": 7
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 8,
        "ffId": "TML_0409_8"
      },
      {
        "h": 5,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_90deg_Right_0405.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_90deg_Right_0405_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 5
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 9,
        "ffId": "TML_0405_9"
      },
      {
        "h": 5,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_90deg_Left_0405.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_90deg_Left_0405_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 3
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 10,
        "ffId": "TML_0405_10"
      },
      {
        "h": 16,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_1608.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_1608.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 2,
            "y": 16
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 16
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 11,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_180deg_0804.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 6,
            "y": 4
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 8,
        "index": 12,
        "ffId": "TML_0804_12"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/TML_1404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/TML_1404.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 14,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 14,
        "index": 13,
        "ffId": "TML_1404_13"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/T-Line_0504.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/T-Line_0504.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 5,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 5,
        "index": 14,
        "ffId": "TML_0504_14"
      }
    ],
    "TRN": [
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BLN_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BLN_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/BLN_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/BLN_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": ""
      }
    ],
    "TVA": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/TVA_0204.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/TVA_0204_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "HY2",
            "x": 2,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 2,
        "index": 0,
        "ffId": "TVA_0204_0"
      }
    ],
    "UPC": [
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/IQ_UP_Converter_0819.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/IQ_UP_Converter_0819_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+Q\"",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "-Q",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+I\"",
            "type": "INP",
            "x": 0,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "-I",
            "type": "INP",
            "x": 0,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "-LO",
            "type": "INP",
            "x": 2,
            "y": 19
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+LO\"",
            "type": "INP",
            "x": 6,
            "y": 19
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RFOUT",
            "type": "OUT",
            "x": 8,
            "y": 7
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 0,
        "ffId": ""
      },
      {
        "h": 19,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Upconverter_0819.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 12
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY1",
            "x": 0,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 17
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "HY2",
            "x": 8,
            "y": 12
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 1,
        "ffId": ""
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/IQ_UP_Converter_0809.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/IQ_UP_Converter_0809_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+Q\"",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+I\"",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "-LO",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "\"+LO\"",
            "type": "INP",
            "x": 6,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "RFOUT",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 2,
        "ffId": ""
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/UPC_0909.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/UPC_0909_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "",
            "tag": "\"+Q\"",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "\"+I\"",
            "type": "INP",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "-LO",
            "type": "INP",
            "x": 2,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "\"+LO\"",
            "type": "INP",
            "x": 7,
            "y": 9
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "RFOUT",
            "type": "OUT",
            "x": 9,
            "y": 2
          }
        ],
        "szUnit": "",
        "tag": "",
        "w": 9,
        "index": 3,
        "ffId": "UPC_0909_3"
      }
    ],
    "VCO": [
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VCO_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/VCO_0409_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VTUNE",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 2,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 0,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "S-O,RS-O/2",
        "w": 4,
        "index": 0,
        "ffId": ""
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VCO_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/VCO_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VTUNE",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "S-O",
        "w": 4,
        "index": 1,
        "ffId": "OSC_0404_8"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/OSC_0809.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/OSC_0809_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VTUNE",
            "type": "INP",
            "x": 8,
            "y": 7
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 8,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 8,
        "index": 2,
        "ffId": "OSC_0809_1"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/OSC_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/OSC_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "OSC",
        "w": 4,
        "index": 3,
        "ffId": "OSC_0404_2"
      },
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VCO_0404_O_O2_O4.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VTUNE",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 4
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "VCO",
            "type": "OUT",
            "x": 4,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "",
            "tag": "",
            "type": "OUT",
            "x": 2,
            "y": 0
          }
        ],
        "szUnit": "XUN",
        "tag": "L-O,S-O/2,R-O/4",
        "w": 4,
        "index": 4,
        "ffId": ""
      }
    ],
    "VRG": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Vreg_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Vreg_0404.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "VRG_0404_0"
      },
      {
        "h": 9,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/Vreg_0409.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/Vreg_0409.svg"
          }
        ],
        "ports": [],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 1,
        "ffId": "VRG_0409_13"
      }
    ],
    "VVA": [
      {
        "h": 4,
        "images": [
          {
            "imageType": "HYB",
            "imageURL": "/svg/hyb/VVA_0404.svg"
          },
          {
            "imageType": "CFG",
            "imageURL": "/svg/cfg/VVA_0404_PUR.svg"
          }
        ],
        "ports": [
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "INP",
            "x": 0,
            "y": 2
          },
          {
            "dat": 0,
            "pUnit": "XUN",
            "tag": "",
            "type": "OUT",
            "x": 4,
            "y": 2
          }
        ],
        "szUnit": "XUN",
        "tag": "",
        "w": 4,
        "index": 0,
        "ffId": "VVA_0404_0"
      }
    ],
    "CMA": [],
    "CON": [],
    "ISO": []
  }
  export default cascadeVault;